<template>
  <div class="caixa-campo-arquivo text-center" @click="openFilesDialog">
    <input ref="fileField" type="file" @change="onFileChange"
      :accept="accept" class="campo-arquivo"/>
    <div v-if="showPreview">
      <span class="icon icon-file"></span>
      <a :href="file.UrlTemporario">{{file.MetaDados.NomeArquivo}}</a>
      <a class="icon icon-x-circle" @click="$emit('file-cleared')"></a>
    </div>
    <div v-else>
      <span class="icon icon-upload"></span>
      <span class="txt">Enviar arquivo</span>
      <at-progress :percent="progress"></at-progress>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/base/_base.scss";
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

	.caixa-campo-arquivo {
		border-color: #ddd!important;
		padding: 15px;
		height: 180px;
		border: $base-border;
		border-radius: 5px;
		width: 200px;
		margin: 10px 10px 4px 10px;
		display: inline-block;

		span {
			display: block;
			font-size: 60px;
			margin: 20px 0;
			color: $c3;

			&.txt {
				@include font-size(12px);
				line-height: 8px;
				padding: 0 !important;
				color: #666;
			}
		}

		a {
			color: #999;
			font-size: 15px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			display: inline-block;
			width: 100%;

			&.icon {
				color: red;
			}
		}

		@include xs {
			width: 100%;
			height: 100%;
			padding: 10px;
			display: block;
			margin:0;

			span {
				overflow: hidden;
				&.icon {
					@include font-size(30px);
					@include line-height(30px);
					padding:0px;
					margin:10px 0 0 0;
				}

				&.txt {
					margin:8px 0;
				}
			}
		}
	}

	.campo-arquivo {
		display: none;
	}
</style>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      progress: 0
    }
  },
  props: {
    accept: {required: false, type: String},
    uploadEndpoint: {required: true, type: String},
    file: {type: Object}
  },
  computed: {
    showPreview: function() { 
      return (this.file != null && this.file !== undefined) 
    }
  },
  methods: {
    openFilesDialog(e) {
      if(e.target.classList.contains('botao-remover')) return e.stopPropagation()

      this.$refs.fileField.click()
    },
    onFileChange(e) {
      const file = e.target.files[0]
      const formData = new FormData()
      formData.append("file", file)
      var dataAtual = new Date();

      return axios({
        url: this.uploadEndpoint,
        method: 'POST',
        data: formData,
        onUploadProgress: progressEvent => {
          if(file === undefined) {
            this.progress = 0;
          } else {
            this.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
          }
        }
      }).then(response => {
        const formattedFile = {
          Nome: response.data.name,
          UrlTemporario: response.data.tempUrl,
          DataEnvio: dataAtual,
          MetaDados: {
            UltimaModificacao: dataAtual,
            DataUltimaModificacao: dataAtual,
            NomeArquivo: file.name,
            Tamanho: file.size,
            Tipo: file.type
          },
          Share: response.data.share,
          Directory: response.data.directory
        }
        this.$emit('uploaded', formattedFile, response)
        this.progress = 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FileInput.vue